import React from "react";
import "../../main.css";
import Features from "./Features";
import styles from "./styles.css"
import landingimg from "../../assets/landing.svg";
import Faqs from "./Faq2";
import SubForm from "./SubForm";
import SubFormy from "./SubFormM";
import Feature from "./Feature";

export default function LandingPage() {
  return (
    <div>
<section className="bg-blueGray-50">
  <div className="overflow-hidden pt-16">
    <div className="container px-4 mx-auto">
      <div className="flex flex-wrap -m-8">
        <div className="w-full min-h-screen justify-center md:w-1/2 p-8">
          <h1 className="mb-0 pt-20  text-6xl md:text-8xl lg:text-10xl font-bold font-heading md:max-w-xl leading-none">Discover New <a className="text-primary">Perspectives</a> Every Day</h1>
          <p className="mb-11 pt-10 text-xl font-medium md:max-w-md">Meet New People Randomly and Talk about Ideas. 
          <br></br>Ideatank Provides Platform to 
          Have Video Call with People Having Interest in Business.
          </p>

          <a
      href="https://www.producthunt.com/posts/ideatank?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-ideatank"
      target="_blank"
    >
      <img
        src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=376900&theme=light&period=daily"
        alt="IdeaTank - Unlock opportunities through 1 on 1 connection with Ideators | Product Hunt"
        style={{ width: "250px", height: "54px" }}
        width="250"
        height="54"
      />
    </a>
          
          <div className="flex flex-wrap -m-2.5 mb-20">
            <div className="w-full md:w-auto p-2.5">
              <div className="block">
                {/* <button className="btn btn-primary rounded" type="button">Join Us</button> */}
              </div>
            </div>
          
          </div>
          <p className="mb-6 text-sm text-gray-500 font-semibold uppercase"></p>
          <div className="flex flex-wrap -m-3">
            <div className="w-auto p-3">
              <img src="flaro-assets/logos/brands/brand.png" alt=""></img>
            </div>
            <div className="w-auto p-3">
              <img src="flaro-assets/logos/brands/brand2.png" alt=""></img>
            </div>
            <div className="w-auto p-3">
              <img src="flaro-assets/logos/brands/brand3.png" alt=""></img>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 p-8">
          <img className="transform hover:-translate-y-16 transition ease-in-out duration-1000" src="flaro-assets/images/headers/header.png" alt="">
          </img>

        {/* gradient start */}
        {/* <div className="absolute z-[0] w-[20%] h-[20%] top-50 pink__gradient" /> */}
        <img className="z[4]" src={landingimg}></img>
        <div className="absolute z-[1] w-[30%] h-[30%] rounded-full yellow__gradient bottom-60" />
        <div className="absolute z-[2] w-[30%] h-[35%] right-30 top-20 blue__gradient" />
        {/* gradient end */}
</div>
      </div>
    </div>
  </div>
</section>
{/* <Features/> */}
<Feature/>
<Faqs/>
{/* <SubForm/> */}
{/* <SubFormy/> */}

<footer className="footer footer-center p-4 bg-base-300 text-base-content">
  <div>
    <p>Copyright © 2023 - All right reserved by Ideatank</p>
  </div>
</footer>
</div>
  );
}
